import * as React from "react";
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  Tooltip,
  DataLabel,
  LineSeries,
} from "@syncfusion/ej2-react-charts";
import axiosClient from "../Utils/axiosClient";
import { useTranslation } from "react-i18next";
import { getRandomColor } from "../Utils/colorUtil";

const LineChart = () => {
  const [data, setData] = React.useState([]);

  const { t } = useTranslation();

  React.useEffect(() => {
    const getChart = async () => {
      try {
        const response = await axiosClient.get("/dashboard/Monthly");

        if (response.status === 200) {
          const formattedData = response.data.map((item) => ({
            ...item,
            month: t(`Months.${item.month}`),
          }));
          setData(formattedData);
        }
      } catch (error) {}
    };
    getChart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ChartComponent
      tooltip={{ enable: true }}
      width="100%"
      primaryXAxis={{
        valueType: "Category",
        labelIntersectAction: "Rotate45",
      }}
    >
      <Inject services={[LineSeries, Legend, Tooltip, DataLabel, Category]} />
      <SeriesCollectionDirective>
        <SeriesDirective
          dataSource={data}
          xName="month"
          yName="messageCount"
          width={2}
          fill={getRandomColor()}
          name={t("Messages")}
          type="Line"
        ></SeriesDirective>
      </SeriesCollectionDirective>
    </ChartComponent>
  );
};

export default LineChart;
